export default "__VITE_ASSET__CQ$ZG$8O__"